import { createTheme } from '@mantine/core'
import { rezolveGrayColors, rezolveGreenColors, rezolvePrimaryColors, rezolveRedColors, rezolveYellowColors } from './mantine.colors'
import { mantineComponents } from './mantine.components'
import { fontSizes } from './mantine.fonts'

export const theme = createTheme({
  cursorType: 'pointer',
  fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  fontSizes,
  primaryColor: 'blue',
  primaryShade: 7,
  colors: {
    'rezolve-primary': rezolvePrimaryColors,
    'blue': rezolvePrimaryColors,
    'green': rezolveGreenColors,
    'yellow': rezolveYellowColors,
    'red': rezolveRedColors,
    'gray': rezolveGrayColors,
  },
  components: mantineComponents,
})
